import { useEffect } from 'react'

export function useDocumentTitle(pageTitle) {
    useEffect(() => {
        const prefix = (pageTitle !== undefined) ? `${pageTitle } — ` : ``
        const title = `${prefix}BIG et Nouf – Conception de sites, d'applications et d'expériences interactives pour dispositifs tactiles.`
        const clean = title.replace(/(<([^>]+)>)/ig, '')

		document.title = clean
		document.querySelector('meta[property="og:title"]').content = clean
    }, [pageTitle])
}

export function useDocumentDescription(pageDescription) {
    useEffect(() => {
        if (pageDescription) {
            const clean = pageDescription.replace(/(<([^>]+)>)/ig, '')
            document.querySelector('meta[name="description"]').content = clean
            document.querySelector('meta[property="og:description"]').content = clean
        }
    })
}

export function useDocumentConfig(pageColor = 'blue', alwaysVisibleHeader = false) {
    useEffect(() => {
        // Color
        if (pageColor === 'orange') {
		    document.body.classList.remove('is-white')
            document.body.classList.add('is-orange')
        }
        else if (pageColor === 'white') {
		    document.body.classList.add('is-white')
            document.body.classList.remove('is-orange')
        }
        else {
            document.body.classList.remove('is-white')
            document.body.classList.remove('is-orange')
        }
        
        // Header visibility
        if (alwaysVisibleHeader === true) {
            document.body.classList.add('header-always-visible')
        }
        else {
            document.body.classList.remove('header-always-visible')
        }
	})
}